import gql from 'graphql-tag'

export default config => {
  const { client } = config

  return {
    limitedWeeklyOrderQtyPerCustomer: async payload => {
      const { start_date, end_date, limit = 5 } = payload

      const query = gql`
        query ($start_date: date!, $end_date: date!, $limit: Int = 5) {
          items: vw_weekly_order_qty_per_customer(
            limit: $limit
            where: {
              start_date: { _gte: $start_date }
              end_date: { _lte: $end_date }
            }
          ) {
            customer_account_id
            end_date
            start_date
            total_orders
            customer {
              company_name
            }
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date,
          limit
        }
      })

      return items
    },
    weeklyOrderQtyPerCustomer: async payload => {
      const { start_date, end_date } = payload

      const query = gql`
        query ($start_date: date!, $end_date: date!) {
          items: vw_weekly_order_qty_per_customer(
            where: {
              start_date: { _gte: $start_date }
              end_date: { _lte: $end_date }
            }
          ) {
            customer_account_id
            end_date
            start_date
            total_orders
            customer {
              company_name
            }
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date
        }
      })

      return items
    },
    weeklySalesPerCustomer: async payload => {
      const { start_date, end_date } = payload

      const query = gql`
        query ($start_date: date!, $end_date: date!) {
          items: vw_weekly_sales_per_customer(
            where: {
              start_date: { _gte: $start_date }
              end_date: { _lte: $end_date }
            }
          ) {
            customer_account_id
            end_date
            start_date
            sales_total
            customer {
              company_name
            }
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date
        }
      })

      return items
    },
    limitedWeeklySalesPerCustomer: async payload => {
      const { start_date, end_date, limit = 5 } = payload

      const query = gql`
        query ($start_date: date!, $end_date: date!, $limit: Int = 5) {
          items: vw_weekly_sales_per_customer(
            limit: $limit
            where: {
              start_date: { _gte: $start_date }
              end_date: { _lte: $end_date }
            }
          ) {
            customer_account_id
            end_date
            start_date
            sales_total
            customer {
              company_name
            }
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date,
          limit
        }
      })

      return items
    },
    weeklyQuantityByTag: async payload => {
      const { start_date, end_date, tag } = payload

      const query = gql`
        query ($start_date: date!, $end_date: date!, $tag: String) {
          items: vw_weekly_item_tag_stats(
            where: {
              start_date: { _gte: $start_date }
              end_date: { _lte: $end_date }
              tag: { _like: $tag }
            }
          ) {
            customer_account_id
            end_date
            start_date
            quantity
            customer {
              company_name
            }
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date,
          tag
        }
      })

      return items
    },
    weeklySalesPerItemGroupPerCustomer: async payload => {
      const { start_date, end_date } = payload

      const query = gql`
        query ($start_date: date!, $end_date: date!) {
          items: vw_weekly_sales_per_item_group_per_customer(
            where: {
              start_date: { _gte: $start_date }
              end_date: { _lte: $end_date }
            }
          ) {
            customer {
              company_name
              id
            }
            item_group {
              description
            }
            top_item_group {
              description
            }
            total_sales
            start_date
            quantity
            end_date
            customer_account_id
            item_group_id
            top_parent_group_id
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date
        }
      })

      return items
    },
    weeklySalesByItemTag: async payload => {
      const { start_date, end_date, tags = [] } = payload

      const query = gql`
        query ($start_date: timestamp!, $end_date: timestamp!, $tags: jsonb) {
          items: fn_weekly_sales_per_customer(
            args: {
              start_date: $start_date
              end_date: $end_date
              filter_tag: $tags
            }
            where: { customer_account_id: { _is_null: false } }
          ) {
            customer {
              company_name
            }
            start_date
            end_date
            sales_total
          }
        }
      `
      const {
        data: { items }
      } = await client.query({
        query,
        variables: {
          start_date,
          end_date,
          tags
        }
      })

      return items
    }
  }
}
